import { CalciteButton, CalciteLabel, 
	//CalciteNotice, 
	CalciteOption, CalcitePanel, CalciteSelect, CalciteStepper, CalciteStepperItem } from "@esri/calcite-components-react";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { graphClosed, graphOpened } from "../../../../../Flux/actions";

import {loadGraphingSelectOptions, loadGraphingData} from '../../../../../Flux/thunks';




const GraphingPanel = ({graphingOptions, initGraphOptions, setGraphOpened, setGraphClosed, startLoadinGraphData}) => {
	//Nulls don't work, we'll use empty strings
	const [dataOptions, SetDataOptions] = useState({
		state: '',
		region: '',
		subregion: '',
		sitecode: '',
		disease: '',
		species: '',

		chartOptions: {
			type: null,
			dataset: null,
			datasetRange: null,
			year: null
		}
	});


	const QuickLineTest = () => {
		SetDataOptions({
			state: 'NJ',
			region: '',
			subregion: '',
			sitecode: '',
			disease: 'Perkinsus',
			species: 'American Oyster',
	
			chartOptions: {
				type: 'line',
				dataset: 'prevalence',
				year: null
			}
		});
	}
	const QuickBoxTest = () => {
		SetDataOptions({
			state: 'NJ',
			region: '',
			subregion: '',
			sitecode: '',
			disease: 'Perkinsus',
			species: 'American Oyster',
	
			chartOptions: {
				type: 'boxplot',
				dataset: 'prevalence',
				year: 'all'
			}
		});
	}
	const QuickBarTest = () => {
		SetDataOptions({
			state: 'NJ',
			region: '',
			subregion: '',
			sitecode: '',
			disease: 'Dermo',
			species: '',
	
			chartOptions: {
				type: 'column',
				dataset: 'prevalence',
				year: 'all'
			}
		});
	}

	const UpdateStateOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			state: _e.target.selectedOption.value,
			region: '',
			subregion: '',
			sitecode: '',
			disease: '',
			species: '',
		});
	}
	const UpdateRegionOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			region: _e.target.selectedOption.value,
			subregion: '',
			sitecode: '',
			disease: '',
			species: '',
		});
	}

	const UpdateSubRegionOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			subregion: _e.target.selectedOption.value,
			sitecode: '',
			disease: '',
			species: '',
		});
	}
	/*
	const UpdateSiteCodeOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			sitecode: _e.target.selectedOption.value,
		});
	}
	*/
	const UpdateDiseaseOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			disease: _e.target.selectedOption.value,
		});
	}
	const UpdateSpeciesOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			species: _e.target.selectedOption.value,
		});
	}

	const UpdateGraphType = (_e) => {
		SetDataOptions({
			...dataOptions,
			chartOptions: {
				type: _e.target.selectedOption.value,
				dataset: 'prevalence',
				year: (_e.target.selectedOption.value === 'line' ? null : 'all')
			}
		});
	}
	const UpdateGraphDataSet = (_e) => {
		const chartOptions = dataOptions.chartOptions;
		chartOptions.dataset = _e.target.selectedOption.value;
		chartOptions.datasetRange = null;
		SetDataOptions({
			...dataOptions,
			chartOptions
		});
	}
	const UpdateGraphDataRange = (_e) => {
		const chartOptions = dataOptions.chartOptions;
		chartOptions.datasetRange = _e.target.selectedOption.value;
		SetDataOptions({
			...dataOptions,
			chartOptions,
		});
	}
	const UpdateGraphDataYear = (_e) => {
		const chartOptions = dataOptions.chartOptions;
		chartOptions.year = _e.target.selectedOption.value;
		SetDataOptions({
			...dataOptions,
			chartOptions
		});
	}



	const GetAvailableSpecies = () => {
		//If we have everything, return the item as is.
		if( dataOptions.state && dataOptions.region && dataOptions.subregion ) {
			return graphingOptions.controlOptions[dataOptions.state][dataOptions.region][dataOptions.subregion].available_species.filter((species)=>{
				return !(['','null'].includes(species.toLocaleLowerCase() ));
			});
		}else if( dataOptions.state && dataOptions.region) {
			//Well, okay let's see if there's a region at least and concat items.
			let myRegionSpecies = [];
			Object.keys(graphingOptions.controlOptions[dataOptions.state][dataOptions.region]).forEach( (subregion, key) =>{
				myRegionSpecies=myRegionSpecies.concat(graphingOptions.controlOptions[dataOptions.state][dataOptions.region][subregion].available_species);
			});

			return [...new Set(myRegionSpecies)].filter((species)=>{
				return !(['','null'].includes(species.toLocaleLowerCase() ));
			});
			/*[dataOptions.subregion].available_species.filter((species)=>{
				return !(['','null'].includes(species.toLocaleLowerCase() ));
			});*/

		}else if( dataOptions.state ) {
			///...okay well how about just s state then.
			let myStateSpecies = [];
			Object.keys(graphingOptions.controlOptions[dataOptions.state]).forEach( (regionName, key) =>{
				Object.keys(graphingOptions.controlOptions[dataOptions.state][regionName]).forEach( (subregion) => {
					myStateSpecies=myStateSpecies.concat(graphingOptions.controlOptions[dataOptions.state][regionName][subregion].available_species);
				});
			});
			return [...new Set(myStateSpecies)].filter((species)=>{
				return !(['','null'].includes(species.toLocaleLowerCase() ));
			});

		}

		//Must at least choose a state, so we'll return nothing	

		return [];

	}

	const GetAvailableDiseases = () => {

		//If we have everything, return the item as is.
		if( dataOptions.state && dataOptions.region && dataOptions.subregion ) {
			return graphingOptions.controlOptions[dataOptions.state][dataOptions.region][dataOptions.subregion].available_diseases.filter((diseases)=>{
				return !(['','null'].includes(diseases.toLocaleLowerCase() ));
			});
		}else if( dataOptions.state && dataOptions.region) {
			//Well, okay let's see if there's a region at least and concat items.
			let myRegionDisease = [];
			Object.keys(graphingOptions.controlOptions[dataOptions.state][dataOptions.region]).forEach( (subregion, key) =>{
				myRegionDisease=myRegionDisease.concat(graphingOptions.controlOptions[dataOptions.state][dataOptions.region][subregion].available_diseases);
			});

			return [...new Set(myRegionDisease)].filter((diseases)=>{
				return !(['','null'].includes(diseases.toLocaleLowerCase() ));
			});
			/*[dataOptions.subregion].available_species.filter((species)=>{
				return !(['','null'].includes(species.toLocaleLowerCase() ));
			});*/

		}else if( dataOptions.state ) {
			///...okay well how about just s state then.
			let myStateDisease = [];
			Object.keys(graphingOptions.controlOptions[dataOptions.state]).forEach( (regionName, key) =>{
				Object.keys(graphingOptions.controlOptions[dataOptions.state][regionName]).forEach( (subregion) => {
					myStateDisease=myStateDisease.concat(graphingOptions.controlOptions[dataOptions.state][regionName][subregion].available_diseases);
				});
			});
			return [...new Set(myStateDisease)].filter((diseases)=>{
				return !(['','null'].includes(diseases.toLocaleLowerCase() ));
			});

		}

		//Must at least choose a state, so we'll return nothing	

		return [];
	}

	const _GetMinAndMaxYears = () => {
		const minAndMaxYear = {
			minYear: 9999,
			maxYear :0
		};
		if( dataOptions.state && dataOptions.region && dataOptions.subregion ) {

			minAndMaxYear.minYear = parseInt(graphingOptions.controlOptions[dataOptions.state][dataOptions.region][dataOptions.subregion].earliest_year);
			minAndMaxYear.maxYear = parseInt(graphingOptions.controlOptions[dataOptions.state][dataOptions.region][dataOptions.subregion].latest_year);
		}else if( dataOptions.state && dataOptions.region) {
			//Well, okay let's see if there's a region at least and concat items.
			


			Object.keys(graphingOptions.controlOptions[dataOptions.state][dataOptions.region]).forEach( (subregion, key) =>{
				const earliestYear = parseInt(graphingOptions.controlOptions[dataOptions.state][dataOptions.region][subregion].earliest_year);
				const latestYear = parseInt(graphingOptions.controlOptions[dataOptions.state][dataOptions.region][subregion].latest_year);

				if( earliestYear < minAndMaxYear.minYear ) {
					minAndMaxYear.minYear = earliestYear;
				}
				if( minAndMaxYear.maxYear < latestYear ) {
					minAndMaxYear.maxYear = latestYear;
				}
			});

		}else if( dataOptions.state ) {
			console.log('[GraphingPanel] Only state selected',graphingOptions.controlOptions[dataOptions.state] )
			///...okay well how about just s state then.
			Object.keys(graphingOptions.controlOptions[dataOptions.state]).forEach( (regionName, key) =>{
				Object.keys(graphingOptions.controlOptions[dataOptions.state][regionName]).forEach( (subregion) => {
					const earliestYear = parseInt(graphingOptions.controlOptions[dataOptions.state][regionName][subregion].earliest_year);
					const latestYear = parseInt(graphingOptions.controlOptions[dataOptions.state][regionName][subregion].latest_year);
	
					if( earliestYear < minAndMaxYear.minYear ) {
						minAndMaxYear.minYear = earliestYear;
					}
					if( minAndMaxYear.maxYear < latestYear ) {
						minAndMaxYear.maxYear = latestYear;
					}
				});
			});
		}
		console.log('[GraphingPanel] Checking min and max year', minAndMaxYear, dataOptions.state, dataOptions.region, dataOptions.subregion  );
		return minAndMaxYear;
	}


	const DisplayChartOptionsToUser = () => {
		if( !dataOptions.chartOptions.type ) {
			return null;
		}

		if( dataOptions.chartOptions.type === 'line' ) {
			return (
				<>
				<CalciteLabel>
					Use Data Set: 
					<CalciteSelect label="Data Set" name="data-set" scale="m" onCalciteSelectChange={UpdateGraphDataSet}>
						<CalciteOption value={'prevalence'} label="Prevalence" selected={dataOptions.chartOptions.dataset === 'prevalence'}></CalciteOption>
					{/*<CalciteOption value={'adv-prevalence'} label="Advanced Prevalence" selected={dataOptions.chartOptions.dataset === 'adv-prevalence'}></CalciteOption>*/}
						<CalciteOption value={'weighted-prevalence'} label="Weighted Prevalence" selected={dataOptions.chartOptions.dataset === 'weighted-prevalence'}></CalciteOption>
					</CalciteSelect>
				</CalciteLabel>
				{/*}<p><em>Line charts plot all available years by year.</em></p>*/}
				
				<CalciteLabel>
					Use Data Range: 
					<CalciteSelect label="Data Set Range" name="data-set-range" scale="m" onCalciteSelectChange={UpdateGraphDataRange}>
						<CalciteOption value={'all'} label="All" selected={dataOptions.chartOptions.datasetRange === 'all'}></CalciteOption>
						<CalciteOption value={'all-jan-june'} label="Data Between January and June" selected={dataOptions.chartOptions.datasetRange === 'all-jan-june'}></CalciteOption>
						<CalciteOption value={'all-july-dec'} label="Data Between July and December" selected={dataOptions.chartOptions.datasetRange === 'all-july-dec'}></CalciteOption>
					</CalciteSelect>
				</CalciteLabel>
				</>
			);
		}

		//If box plot or bar chart, give the other options

		const renderOptions = () => {
			const {minYear, maxYear} = _GetMinAndMaxYears();
			const myCalciteOptions = [];
			for(let i=maxYear;i>=minYear;i--) {
				myCalciteOptions.push(i);
			}
			return myCalciteOptions.map( (yearOpt) => {
				return (<CalciteOption value={yearOpt} label={yearOpt} selected={dataOptions.chartOptions.year === yearOpt}></CalciteOption>);
			});
		}

		return (
			<>	
				<CalciteLabel>
					Use Data Set: 
					<CalciteSelect label="Data Set" name="data-set" scale="m" onCalciteSelectChange={UpdateGraphDataSet}>
						{
							dataOptions.chartOptions.type === 'column'
							|| dataOptions.chartOptions.type === 'boxplot'
							? (
								<>
								<CalciteOption value={'prevalence'} label="Prevalence" selected={dataOptions.chartOptions.dataset === 'prevalence'}></CalciteOption>
								<CalciteOption value={'weighted-prevalence'} label="Weighted Prevalence" selected={dataOptions.chartOptions.dataset === 'weighted-prevalence'}></CalciteOption>
								</>
							): null
						}
						{/*<CalciteOption value={'all'} label="All" selected={dataOptions.chartOptions.dataset === 'all'}></CalciteOption>*/}
					</CalciteSelect>
				</CalciteLabel>
				<p><em>Bar charts and box plots show data by month.</em></p>
				
				<CalciteLabel>
					Select Year: 
					<CalciteSelect label="Years of By Month" name="years-by-month" scale="m" onCalciteSelectChange={UpdateGraphDataYear}>
						<CalciteOption value={'all'} label="- All Years -" selected={dataOptions.chartOptions.dataset === 'all'}></CalciteOption>
						{renderOptions()}
					</CalciteSelect>
				</CalciteLabel>
			</>
		);

	}


	const StartLoadingGraphData = () => {
		console.log('Loading graph data using the following data option object: ', dataOptions);


		console.log('Compiler appeaser', startLoadinGraphData(dataOptions));
	}

	/*
	const DisplayChoicesPreviouslyMade = () => {
		const createLi = [];
		if( dataOptions.state ) {
			createLi.push(`State: ${dataOptions.state}`);
		}
		if( dataOptions.region ) {
			createLi.push(`Region: ${dataOptions.region}`);
		}
		if( dataOptions.subregion ) {
			createLi.push(`Subregion: ${dataOptions.subregion}`);
		}
		if( dataOptions.sitecode ) {
			createLi.push(`Sitecode: ${dataOptions.sitecode}`);
		}
		if( dataOptions.species ) {
			createLi.push(`Species: ${dataOptions.species}`);
		}
		if( dataOptions.disease ) {
			createLi.push(`Pathogen: ${dataOptions.disease}`);
		}
		
		if( dataOptions.chartOptions) {
			if( dataOptions.chartOptions.type ==='boxplot' ) {
				createLi.push(`Chart Type: Box Plot`);
			}
			if( dataOptions.chartOptions.type ==='line' ) {
				createLi.push(`Chart Type: Line Chart`);
			}
			if( dataOptions.chartOptions.type ==='column' ) {
				createLi.push(`Chart Type: Bar Chart`);
			}
			
			if( dataOptions.chartOptions.dataset ) {
				createLi.push(`Dataset: ${dataOptions.chartOptions.dataset}`);
			}
			if( dataOptions.chartOptions.year ) {
				createLi.push(`Year: ${dataOptions.chartOptions.year}`);
			}else{
				if( dataOptions.chartOptions.type ==='line' ) {
					if( dataOptions.chartOptions.datasetRange === 'all' ) {
						createLi.push(`Year: All Available`);
					}else if( dataOptions.chartOptions.datasetRange === 'all-jan-june' ) {
						createLi.push(`Year: All Available Between January and June`);
					}else if( dataOptions.chartOptions.datasetRange === 'all-july-dec' ) {
						createLi.push(`Year: All Available Between July and December`);
					}
				}else{
					createLi.push(`Year: All Available`);
				}
			}
		}
		return( 
			<ul>
				{createLi.map( (liItem, key) => { return <li key={key}>{liItem}</li>})}
			</ul>
		)
	}
*/
	useEffect( () =>{
		initGraphOptions();
	}, [initGraphOptions] )

	
	return (
		<CalcitePanel loading={graphingOptions.isInitializing}>
			<div className="content-area">
				{ process.env.NODE_ENV === 'development' ? <>
				<CalciteButton  onClick={(_e) => {
					QuickBarTest();
					//startLoadinGraphData(dataOptions);
				}}> BAR QUICK TEST </CalciteButton>
				<CalciteButton  onClick={(_e) => {
					QuickBoxTest();
					//startLoadinGraphData(dataOptions);
				}}> BOXPLOT QUICK TEST </CalciteButton><CalciteButton  onClick={(_e) => {
					QuickLineTest();
					//startLoadinGraphData(dataOptions);
				}}> LINE QUICK TEST </CalciteButton>
				</> : null }
				<CalciteStepper layout="vertical" scale="s" icon={true}>
					<CalciteStepperItem className="no-outline" 
					itemTitle="Location" itemSubtitle="Select the area you want to look at." 
					complete={dataOptions.state || null}>
						<CalciteLabel>
							State: 
							<CalciteSelect label="State" name="state" scale="m" onCalciteSelectChange={UpdateStateOption}>
								<CalciteOption value={''} label="- Select State-" selected={!dataOptions.state}></CalciteOption>
								{Object.keys(graphingOptions.controlOptions).map( (stateName, key) =>{
									return (<CalciteOption key={key} value={stateName} selected={dataOptions.state === stateName}>{stateName}</CalciteOption>);
								})}
							</CalciteSelect>
						</CalciteLabel>
						<CalciteLabel disabled={!dataOptions.state || null} >
							Region: 
							<CalciteSelect label="Region" name="region" scale="m" onCalciteSelectChange={UpdateRegionOption}>
								<CalciteOption value={''} label=" - All Regions -" selected={!dataOptions.region}></CalciteOption>
								{
									dataOptions.state 
									? Object.keys(graphingOptions.controlOptions[dataOptions.state]).map( (regionName, key) =>{
										return (<CalciteOption key={key} value={regionName} selected={dataOptions.region === regionName} label={regionName}></CalciteOption>);
									}) : null
								}	
							</CalciteSelect>
						</CalciteLabel>
						<CalciteLabel disabled={!dataOptions.state || !dataOptions.region || null} >
							Sub-region: 
							<CalciteSelect label="Sub-region" name="sub-region" scale="m" onCalciteSelectChange={UpdateSubRegionOption}>
								<CalciteOption value={''} label=" - All Sub-regions -" selected={!dataOptions.subregion}></CalciteOption>
								{
									dataOptions.state && dataOptions.region
									? Object.keys(graphingOptions.controlOptions[dataOptions.state][dataOptions.region]).map( (subregionName, key) =>{
										return (<CalciteOption key={key} value={subregionName} selected={dataOptions.subregion === subregionName} label={subregionName}></CalciteOption>);
									}) : null
								}	
							</CalciteSelect>
						</CalciteLabel>
						{/*
						<CalciteLabel disabled={!dataOptions.state || !dataOptions.region || !dataOptions.subregion || null} >
							Sitecode: 
							<CalciteSelect label="Sitecode" name="sitecode" scale="m" onCalciteSelectChange={UpdateSiteCodeOption}>
								<CalciteOption value={''} label=" - All Site-Codes -" selected={!dataOptions.sitecode}></CalciteOption>
								{
									dataOptions.state && dataOptions.region && dataOptions.subregion
									? graphingOptions.controlOptions[dataOptions.state][dataOptions.region][dataOptions.subregion].available_sitecodes.filter((sitecode)=>{
										return !(['','null'].includes(sitecode.toLocaleLowerCase() ));
									}).map( (sitecode, key) =>{
										return (<CalciteOption key={key} value={sitecode} selected={dataOptions.sitecode === sitecode} label={sitecode}></CalciteOption>);
									}) : null
								}	
							</CalciteSelect>
						</CalciteLabel>
						*/}
					</CalciteStepperItem>
					<CalciteStepperItem 

					 	className="no-outline"
					 	disabled={!dataOptions.state || null}
						complete={dataOptions.disease || dataOptions.species || null }
						itemTitle="Species / Pathogen" itemSubtitle="(Optional) Choose a species and / or pathogen">
{/* Species should filter disease drop down */}
						<CalciteLabel>
							Species: 
							<CalciteSelect label="Species" name="species" scale="m" onCalciteSelectChange={UpdateSpeciesOption}>
								<CalciteOption value={''} label="- All Species -" selected={!dataOptions.species}></CalciteOption>
								{
									GetAvailableSpecies()
									.map( (species, key) =>{
										return (<CalciteOption key={key} value={species} selected={dataOptions.species === species} label={species}></CalciteOption>);
									}) 
								}	
							</CalciteSelect>
						</CalciteLabel>
						<CalciteLabel>
							Pathogen: 
							<CalciteSelect label="Pathogen" name="disease" scale="m" onCalciteSelectChange={UpdateDiseaseOption}>
								<CalciteOption value={''} label=" - All Pathogens -" selected={!dataOptions.disease}></CalciteOption>
								{
									GetAvailableDiseases()
									.map( (disease, key) =>{
										return (<CalciteOption key={key} value={disease} selected={dataOptions.disease === disease} label={disease}></CalciteOption>);
									})
								}	
							</CalciteSelect>
						</CalciteLabel>
					</CalciteStepperItem>
					<CalciteStepperItem 
					 	className="no-outline"
					 	disabled={!dataOptions.state || null}
						itemTitle="Chart Options" itemSubtitle="Select your chart type and options"
						complete={dataOptions.chartOptions.type || null}
						>
						<CalciteLabel >
							Chart Type: 
							<CalciteSelect label="State" name="state" scale="m" onCalciteSelectChange={UpdateGraphType}>
								<CalciteOption value={''} label="- Select Chart Type -" selected={!dataOptions.chartOptions.type}></CalciteOption>
								<CalciteOption value={'line'} label="Line Chart"  selected={dataOptions.chartOptions.type==='line'}></CalciteOption>
								<CalciteOption value={'column'} label="Bar Chart" selected={dataOptions.chartOptions.type==='column'}></CalciteOption>
								<CalciteOption value={'boxplot'} label="Box Plot" selected={dataOptions.chartOptions.type==='boxplot'}></CalciteOption>
							</CalciteSelect>
						</CalciteLabel>
						
						{DisplayChartOptionsToUser()}




					</CalciteStepperItem>
					{/*
	
					<CalciteStepperItem 
					 	className="no-outline"
					 	disabled={!dataOptions.chartOptions.type || !dataOptions.state || null}
						itemTitle="Review" itemSubtitle="Confirm choices">
						{DisplayChoicesPreviouslyMade()}
						<CalciteButton  onClick={(_e) => {
							StartLoadingGraphData();
							//startLoadinGraphData(dataOptions);
						}}> Load Data </CalciteButton>
					</CalciteStepperItem>
					*/}
					<CalciteButton 
					disabled={!dataOptions.chartOptions.type || !dataOptions.state || undefined}
					onClick={(_e) => {
							StartLoadingGraphData();
							//startLoadinGraphData(dataOptions);
						}}> Load Data </CalciteButton>
				</CalciteStepper>
			</div>
		</CalcitePanel>
	);
	
}
const mapStateToProps = (state) => ({
	graphingOptions: state.graphingOptions
});
// what actions are we allowed to use
const mapDispatchToProps = (dispatch) => ({
	initGraphOptions: () => {dispatch(loadGraphingSelectOptions())},
	setGraphOpened: () => {dispatch(graphOpened())},
	setGraphClosed: () => {dispatch(graphClosed())},
	startLoadinGraphData: (dataOptions) => { dispatch(loadGraphingData(dataOptions))}
});

export default connect(mapStateToProps, mapDispatchToProps)(GraphingPanel);



//Trash area ready for delete
/*
						<CalciteButton  color="red" appearance="outline" onClick={(_e)=>{setGraphClosed()}}>Close Graph</CalciteButton>&nbsp;
<div className="content-area">
	<ul>
		<li>is initializing? {graphingOptions.isInitializing ? 'Yes' : 'No'}</li>
		<li>is ready? {graphingOptions.isReady ? 'Yes' : 'No'}</li>
		<li>Graph is open? {graphingOptions.isGraphOpen ? 'Yes' : 'No'}</li>
	</ul>
	<CalciteButton disabled={true} onClick={(_e)=>{setGraphOpened()}}>Open Graph</CalciteButton>&nbsp;
	<hr/>
	

</div>
*/
